import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-loading-overlay" }

import { NSpin } from "naive-ui";

export default /*@__PURE__*/_defineComponent({
  __name: 'SubLoading',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NSpin), { size: "large" })
  ]))
}
}

})